import {aspectNames} from 'common-types'
import {withActions} from 'carmi-host-extensions'

export const CSS_CONTAINER = 'CSS_CONTAINER'
export const stylableModuleName = 'stylable-santa-flatten'
export const stylableRequestFullJsonResponse = 'getAnnotatedStyle'

export interface StylableStore {
    pagesStylableCss: {
        [id: string]: string
    }
}

export const name = aspectNames.StylableAspect

const setPagesCss = withActions(({setPageStylableCss}, pageId, cssPojo) => {
    setPageStylableCss(pageId, cssPojo.css)
})
export const functionLibrary = {
    setPagesCss
}

export const defaultModel: StylableStore = {
    pagesStylableCss: {}
}
